module.exports = __webpack_public_path__ + "static/media/speakers_carousel_landing_1.4ed16e21.png";


//////////////////
// WEBPACK FOOTER
// ./src/apps/BCOMS/resources/speakers_carousel_landing_1.png
// module id = 1138
// module chunks = 0